import React from 'react';
import {Container, Row, Col,Form, FormGroup, Input,Button} from 'reactstrap';
import Axios from 'axios';
import Config from '../../Core/Config.js';
import UserManager from '../../Core/UserManager';
import './Profile.css';

var ChangePasswordUserModel={
    UserId:"",
    OldPassword:"",
    NewPassword:""
}
var $ = require('jquery');
class ChangePassword extends React.Component {
    constructor(props) 
    {
        super(props);
        this.state = {
            isLoading: true,
            password1:'',
            password2:'',
            password3:''
        }
        this.setPassword1=this.setPassword1.bind(this);
        this.setPassword2=this.setPassword2.bind(this);
        this.setPassword3=this.setPassword3.bind(this);
        this.updateProfileData=this.updateProfileData.bind(this);
    }
    
    
    /**********************updateProfileData***************************** */
    updateProfileData(Pass,NPass,RPass){
        if(Pass ===""){
           $('#password').addClass('pass_redline');
           $('#password').removeClass('pass_line');
        }
        else{
            if(NPass===RPass){
                ChangePasswordUserModel.UserId=UserManager.getUserToken();
                ChangePasswordUserModel.OldPassword=Pass;
                ChangePasswordUserModel.NewPassword=NPass;
                Axios.post(Config.domain_pic + "/ChangePassword",ChangePasswordUserModel)         
                
                    .then((result) => {
                        // console.log("result.userprofile: ", JSON.stringify(result.data));
                        if(result.data==="-5"){
                            $('#pass-error').addClass('dblock');
                            $('#pass-error').removeClass('dnone');
                        }
                        else{
                            $('#success_update').addClass('success_update_block');
                            $('#success_update').removeClass('success_update_none');
                        }
                    })
                    .catch((error) => {
                        alert(error) 
                    })
            }
            else{
                $('#error_update').addClass('error_update_block');
                $('#error_update').removeClass('error_update_none');
            }
        }
    }
    /****************setPassword****************** */
    setPassword1(event){
        
        this.setState({
            password1:event.target.value
        });
            
           $('#password').addClass('pass_line');
           $('#password').removeClass('pass_redline');
           $('#pass-error').addClass('dnone');
           $('#pass-error').removeClass('dblock');
           $('#success_update').addClass('success_update_none');
           $('#success_update').removeClass('success_update_block');
    }
    setPassword2(event){
        this.setState({
            password2:event.target.value
        });
        $('#success_update').addClass('success_update_none');
        $('#success_update').removeClass('success_update_block');
        $('#error_update').addClass('error_update_none');
        $('#error_update').removeClass('error_update_block');
    }
    setPassword3(event){
        this.setState({
            password3:event.target.value
        });
        if(this.state.password3===this.state.password2){
            $('#password3').addClass('pass_line');
            $('#password3').removeClass('pass_redline');
        }
        else{
            
            $('#password3').addClass('pass_redline');
            $('#password3').removeClass('pass_line');
            $('#success_update').addClass('success_update_none');
            $('#success_update').removeClass('success_update_block');
            $('#error_update').addClass('error_update_none');
            $('#error_update').removeClass('error_update_block');
        }
    }
      /**************************************************************************** */
    render() {
        
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4> تغییر رمز عبور</h4>
                    </Col>
                </Row>
                <br />
                <Container>
                    
                            <Row className="profile">
                                
                                <Col sm='12' md='9'>
                                    <Row>
                                    <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box"> رمز عبور فعلی : </Col>
                                                <Col sm='12' md='6' className="content_bx">
                                                    <Form>
                                                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                                            <Input type="password" name="password" id="password" value={this.state.password1} onChange={this.setPassword1} className="pass_line"  />
                                                            <div id="pass-error" className="dnone">رمز عبور اشتباه است</div>
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">رمز عبور جدید : </Col>
                                                <Col sm='12' md='6' className="content_bx">
                                                    <Form>
                                                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                                            <Input type="password" name="password"  value={this.state.password2} onChange={this.setPassword2} className="pass_line"  />
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">تکرار رمز عبور : </Col>
                                                <Col sm='12' md='6' className="content_bx">
                                                    <Form>
                                                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                                            <Input type="password" name="password" id="pass3"  value={this.state.password3} onChange={this.setPassword3} className="pass_line"  />
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Col>
                                        
                                        
                                    </Row>
                                    
                                </Col>
                                <Col sm='12'>
                                        <div id="success_update" className="success_update_none ">اطلاعات حساب کاربری شما با موفقیت ویرایش شد</div>
                                        <div id="error_update" className="error_update_none ">تکرار رمز عبور باید با رمز عبور جدید یکی باشد</div>

                                        <div className="buttons">
                                            <Button onClick={()=>{this.updateProfileData(this.state.password1,this.state.password2,this.state.password3)}}>
                                                ذخیره
                                            </Button> &nbsp;
                                            <Button >
                                                بازیابی رمز عبور
                                            </Button>
                                        </div>
                                </Col>
                            </Row>
                                
                        
                       
                    </Container>
                <br />
            </div>
        );
    }
}
export default ChangePassword;


// WEBPACK FOOTER //
// ./src/components/Profile/ChangePassword.js